<template>
    <div class="pa-4">
        <v-card class="mt-2 py-2">
            <v-form ref="productionForm" id="productionForm" v-model="valid">
                <v-toolbar flat>
                    <v-toolbar-title>Produksi</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical />
                    <v-spacer />
                    <v-btn color="grey" dark class="mb-2 mr-2" @click="$router.go(-1)" small>
                        <v-icon small>mdi-arrow-left</v-icon>
                        Back
                    </v-btn>
                </v-toolbar>
                <div class="mt-3">
                    <v-row class="my-2 mx-1">
                        <v-col cols="6">
                            <v-simple-table dense style="width:600px;">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th width="150"></th>
                                            <th width="70" class="text-center">Hari</th>
                                            <th>Tanggal</th>
                                        </tr>
                                        <tr>
                                            <td>Produksi</td>
                                            <td class="text-center">{{ dayProduction }}</td>
                                            <td style="padding-top: 4px; padding-bottom: 4px;">
                                                <div v-if="isReadonly" class="text-no-wrap" style="width: 150px;">
                                                    {{ formattedSelectedDate }}
                                                </div>
                                                <v-menu
                                                    v-else
                                                    v-model="menuDate"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="auto"
                                                >
                                                    <template v-slot:activator="{ on, attrs}">
                                                        <v-text-field
                                                            dense
                                                            outlined
                                                            readonly
                                                            hide-details="auto"
                                                            v-model="formattedSelectedDate"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            style="width: 150px;"
                                                        />
                                                    </template>
                                                    <v-date-picker v-model="selectedDate" @input="handleDateChange" />
                                                </v-menu>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Delivery</td>
                                            <td class="text-center">{{ dayDelivery }}</td>
                                            <td>{{ deliveryDate }}</td>
                                        </tr>
                                        <tr>
                                            <td>Expired</td>
                                            <td class="text-center"></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>Remarks</td>
                                            <td class="text-center"></td>
                                            <td>
                                                <div v-if="isReadonly" class="py-2">
                                                    {{ remarks || '-' }}
                                                </div>
                                                <v-text-field v-else v-model="remarks" dense outlined hide-details="auto" />
                                            </td>
                                        </tr>
                                    </thead>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                    <v-row class="my-2 mx-1">
                        <v-col>
                            <v-simple-table dense>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th style="width: 10px;"></th>
                                            <th style="width: 100px;"></th>
                                            <th class="text-center">Total Produksi</th>
                                            <th class="text-center text-no-wrap">Total Pengurangan</th>
                                            <th></th>
                                            <th></th>
                                            <th class="text-center" :colspan="totalCoordinator">Total Koordinator</th>
                                        </tr>
                                        <tr>
                                            <th></th>
                                            <th></th>
                                            <th class="text-center">{{ totalQty }}</th>
                                            <th class="text-center" style="padding-top: 4px; padding-bottom: 4px;">
                                                <div v-if="isReadonly" class="py-2">
                                                    {{ totalAdjustment }}
                                                </div>
                                                <v-text-field
                                                    v-else
                                                    type="number"
                                                    v-model="totalAdjustment"
                                                    @input="onTotalAdjustmentChange"
                                                    dense
                                                    hide-details
                                                    outlined
                                                    style="width: 100%;"
                                                />
                                            </th>
                                            <th></th>
                                            <th></th>
                                            <th :colspan="totalCoordinator" class="text-center">{{ totalCoordinator }}</th>
                                        </tr>
                                        <tr>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th style="width:50px;" class="text-center">Pengurangan Produksi</th>
                                            <th style="width:50px;" class="text-center text-no-wrap">Total Aktual <br/>Produksi</th>
                                            <th></th>
                                            <th v-if="totalCoordinator == 0"></th>
                                            <th v-for="(coordinator, idc) in coordinators" :key="idc" class="text-center">{{ coordinator.name }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, idx) in items" :key="idx">
                                            <td>{{ idx + 1 }}</td>
                                            <td class="text-no-wrap">{{ item.variant_name }} ({{ item.variant_size }}ML)</td>
                                            <td class="text-center">{{ item.qty_order }}</td>
                                            <td class="text-center" style="padding-top: 2px; padding-bottom: 2px;">
                                                <div v-if="isReadonly" class="py-1">
                                                    {{ item.qty_adjustment }}
                                                </div>
                                                <v-text-field
                                                    v-else
                                                    type="number"
                                                    v-model="item.qty_adjustment"
                                                    :value="onQtyAdjustmentChange(item, idx)"
                                                    dense
                                                    hide-details
                                                    outlined
                                                    style="width: 100%;"
                                                />
                                            </td>
                                            <td class="text-center">{{ item.qty_produced }}</td>
                                            <td></td>
                                            <td v-if="totalCoordinator == 0"></td>
                                            <td v-for="(coordinator, idc) in coordinators" :key="idc" class="text-center">
                                                {{ getQtyCoordinator(item.variant_code, coordinator.code, item.qty_produced) }}
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td class="text-center">{{ totalQtyAdjustment }}</td>
                                            <td></td>
                                            <td v-if="totalCoordinator == 0"></td>
                                            <th :colspan="totalCoordinator + 1" class="text-center"></th>
                                        </tr>
                                    </tfoot>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </div>
                <v-card-actions class="pr-4 mt-3 mx-5">
                    <v-spacer />
                    <v-btn v-if="!isReadonly" depressed color="primary" :disabled="status != ''" @click="saveProduction">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    data() {
        return {
            valid: true,
            saveProgress: false,
            menuDate: false,
            selectedDate: '',
            deliveryDate: '',
            dayProduction: '',
            dayDelivery: '',
            totalAdjustment: 0,
            remarks: '',
            status: '',
            items: [],
            coordinators: [],
            coordinatorItems: [],
        }
    },

    computed: {
        isReadonly() {
            return this.$route.query.readonly == '1' || this.$route.query.mode == 'view';
        },
        formattedSelectedDate() {
            return `${this.selectedDate}`;
        },
        totalQty() {
            return this.items.reduce((total, item) => total + Number(item.qty_order), 0)
        },
        totalQtyAdjustment() {
            return this.items.reduce((total, item) => total + Number(item.qty_adjustment), 0)
        },
        totalCoordinator() {
            return this.coordinators.length;
        },
    },

    mounted() {
        
    },

    async created() {
        this.selectedDate = new Date().toISOString().split('T')[0];
        const prod_code = this.$route.params.code;
        if (prod_code == 'new') {
            this.getDataFromPO();
        } else {
            this.getData(prod_code);
        }
    },

    methods: {
        async getDataFromPO() {
            let response = await this.$store.dispatch('massproduction/getDataFromPO', {date: this.selectedDate});
            this.selectedDate = response.production_date;
            this.dayProduction = response.production_day;
            this.deliveryDate = response.delivery_date;
            this.dayDelivery = response.delivery_day;

            this.items = response.items;
            this.coordinators = response.coordinators;
            this.coordinatorItems = response.coordinator_items;
        },
        async getData(prod_code) {
            let response = await this.$store.dispatch('massproduction/getObj', {code: prod_code})
            this.selectedDate = response.production_date;
            this.dayProduction = response.production_day;
            this.dayDelivery = response.delivery_day;
            this.deliveryDate = response.delivery_date;
            this.status = response.status;
            this.remarks = response.remarks;
            this.items = response.items;
            this.coordinators = response.coordinators;
            this.coordinatorItems = response.coordinator_items;
        },
        async handleDateChange(value) {
            if (this.isReadonly) return;
            this.selectedDate = value;

            this.getData();

            this.menuDate = false;
        },
        calculateQtyAdjustment(item) {
            let result = 0;

            if (this.totalQty > 0) {
                const persen = (item.qty_order / this.totalQty) * 100;
                
                result = Math.round(persen * this.totalAdjustment / 100);
            }

            return result;
        },
        onTotalAdjustmentChange() {
            if (this.isReadonly) return;
            this.items = this.items.map(item => ({
                ...item,
                qty_adjustment: this.calculateQtyAdjustment(item),
            }));
        },
        onQtyAdjustmentChange(item, index) {
            if (this.isReadonly) return item.qty_adjustment;
            let result = 0;
            result = Number.parseInt(item.qty_order) + Number.parseInt(item.qty_adjustment);
            this.$set(this.items[index], 'qty_produced', result);
            return item.qty_adjustment;
        },
        calculateQtyProduced(item) {
            let result = 0;
            result = item.qty_produced;

            return result;
        },
        getQtyCoordinator(variant_code, coordinator_code, qty_produced) {
            let result = 0;
            console.log(variant_code);
            console.log(coordinator_code);
            console.log(qty_produced);

            const coordinatorItem = this.coordinatorItems.find(item => item.coordinator_code == coordinator_code
                && item.variant_code == variant_code
            );

            const qtyOrder = this.items.filter(item => item.variant_code == variant_code)
                .reduce((total, item) => total + Number(item.qty_order), 0);

            if (coordinatorItem) {
                if (qtyOrder == qty_produced) {
                    result = coordinatorItem.qty_order;
                } else {
                    const persen = Math.round(coordinatorItem.qty_order / qtyOrder * 100);
                    // console.log(coordinator_code);
                    // console.log(`qty_produced : ${qty_produced}`);
                    // console.log(`qty_order : ${coordinatorItem.qty_order}`);
                    // console.log(`qty_all_order : ${qtyOrder}`);
                    // console.log(`persen : ${persen}`);

                    result = Math.round(qty_produced * persen / 100);
                    
                }
            }

            return result;
        },
        async saveProduction() {
            await this.$refs.productionForm.validate();

            if (!this.valid) return;

            this.saveProgress = true;
            
            const prod_no = moment(this.selectedDate).format('YYYYMMDD');

            const payload = {
                'prod_no': prod_no,
                'production_date': this.selectedDate,
                'remarks': this.remarks,
                'variants': this.items,
            };

            const result = await this.$store.dispatch('massproduction/save', payload);

            if (result.status == 200 || result.status == 201) {
                // this.$router.go(-1)
                this.$router.push(`/mass-production`);
                this.saved = true
            } else {
                this.saveError = true
            }

            this.saveProgress = false
        }
    }
}
</script>